@if (demoMode.isDemo()) {
  <div class="demo-banner">
    <span class="demo-banner-text">{{ 'demo.bannerText' | translate }}</span>
    <a [href]="signUpUrl" class="demo-banner-cta">{{ 'demo.bannerCta' | translate }}</a>
  </div>
}
